import type { QueryKey } from "@tanstack/react-query";
import { getListLorawanDeviceKeysQueryKey } from "./orval/generated/lorawan-device-keys";
import { getListSproutLogsQueryKey } from "./orval/generated/sprout-logger";
import { getListSproutVerificationsQueryKey } from "./orval/generated/sprout-verification";

/**
 * For screens people open specifically to see current state: always refetch on mount and focus, rather
 * than serving the global 30-minute cache.
 *
 * `useGetDeviceDebugInfo` needs this too but passes it at its call site — its key nests under a device id
 * (`["devices", id, "debug-info"]`), and query defaults only match by prefix.
 */
export const liveStateQueryOptions = { staleTime: 0 };

/**
 * Query key roots registered with `liveStateQueryOptions`. Built from the generated key getters so an
 * Orval rename can't silently orphan an entry. Device and stream queries are deliberately absent: the
 * polling service keeps them fresh, and a short staleTime would add a second refresh loop.
 */
export const liveStateQueryRoots: QueryKey[] = [
    getListSproutLogsQueryKey(),
    getListSproutVerificationsQueryKey(),
    getListLorawanDeviceKeysQueryKey(),
];
